const dateTimeFmt = new Intl.DateTimeFormat("pl-PL", {
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

const timeFmt = new Intl.DateTimeFormat("pl-PL", { hour: "2-digit", minute: "2-digit" });
const monthFmt = new Intl.DateTimeFormat("pl-PL", { month: "short" });

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d.getTime()) ? "—" : dateTimeFmt.format(d);
}

export function formatTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d.getTime()) ? "—" : timeFmt.format(d);
}

/** Day-of-month + abbreviated month, for the upcoming-events date chip. */
export function dayChip(iso: string): { day: string; month: string } {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return { day: "—", month: "" };
  return { day: String(d.getDate()), month: monthFmt.format(d).replace(".", "") };
}
